module.exports = "/assets/data/ca84daf0b989dc4a20ca6d3e0c1e3f8d-DG8.data.json";